import { apiSlice } from "../../app/api/apiSlice";

export const quickPricerApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        quickPricer: builder.mutation({
            query: (data) => ({
                url: "/api/v1/loan/quick_pricer/",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useQuickPricerMutation } = quickPricerApiSlice;
